import React, { Component } from 'react';

export default class Third extends Component {
    render() {
        const scrolling = () => {
            document.querySelector('#fourth').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        };

        return (
            <section id="third" className="panel">
                <div className="content span-5-5">
                    <div className="medium">
                        <h1 className="major">
                            Projects&nbsp;
                            <i className="fas fa-code"></i>
                        </h1>
                        <p className="justifying">
                            The projects I have to showcase unfortunately don't fully reflect my current experience, as
                            balancing a full-time job leaves limited time for side projects. Nevertheless, I strive to
                            stay updated with the latest technologies and continuously deepen my skills. My most recent
                            project explores AI—check it out in the next section!
                            <br />
                            My experience mostly lies in{' '}
                            <b>React.js / Next.js / JavaScript with TypeScript, Redux and Flutter</b>. Next to these I'm
                            skilled in A/B testing with <b>Unleash</b>, and in automated testing with{' '}
                            <b>Cypress and Jest</b>. When it comes to design systems, I work confidently with{' '}
                            <b>Figma, MaterialUI, and Storybook</b>. I originally learned full-stack web development
                            (React.js and <b>Node.js</b>) during a coding bootcamp in Amsterdam, and I continue to build
                            on that foundation.
                        </p>
                    </div>
                    <button className="arrow" onClick={scrolling}>
                        <i className="arrow__icon fas fa-chevron-circle-right"></i>
                    </button>
                </div>
            </section>
        );
    }
}
